/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

//import { ICustomBuyboxData } from '../custom-buybox.data';
//import { ICustomBuyboxProps } from '../custom-buybox.props.autogenerated';
import { IBuyboxExtentedProps, IBuyboxCommonData, IBuyboxCallbacks } from '@msdyn365-commerce-modules/buybox';
import { CommercePropertyValue } from '@msdyn365-commerce/retail-proxy';
import { ICustomBuyboxResources } from '../custom-buybox.props.autogenerated';

type ICBBTypeState = {
    isRentSelected: boolean;
    isUsedSelected: boolean;
    isLeasedSelected: boolean;
    isNewSelected: boolean;
    onLoadRentChecked: boolean;
    isFirstRender: boolean;
    isNoOptions: boolean;
};

export function getBuyboxProductType(
    props: IBuyboxExtentedProps<IBuyboxCommonData>,
    state: ICBBTypeState,
    resources: ICustomBuyboxResources,
    callbacks: IBuyboxCallbacks
): React.ReactElement | null | undefined {
    const {
        data: {
            product: { result: product }
        }
    } = props;

    // const { isRentSelected, isLeasedSelected, isNewSelected, isUsedSelected } = state;

    let showRental = false;
    let showUsed = false;
    let showLeased = false;
    let showBuyNew = false;
    let showProductTypeError = false;
    let showNoOptions = false;
    let usedEquipmentFlag = false;
    // let onLoadRentChecked = true;

    const updateExtensionProperty = (_key: string, _value: CommercePropertyValue, addIfNotExist: boolean = false) => {
        let isKeyExist = false;
        product?.ExtensionProperties?.map(function(property) {
            if (property.Key === _key) {
                isKeyExist = true;
                property.Value!.BooleanValue = _value.BooleanValue;
            }
        });
        if (isKeyExist === false && addIfNotExist) {
            product?.ExtensionProperties?.push({ Key: _key, Value: _value });
        }
    };

    const onChange = (type: string) => {
        state.isFirstRender = false;
        callbacks.updateErrorState({ configureErrors: {} });
        updateExtensionProperty('productTypeError', { BooleanValue: false }, true);
        if (type === 'rent') {
            if (state.isRentSelected === false) {
                state.isRentSelected = true;
                updateExtensionProperty('isRentSelected', { BooleanValue: true }, true);
                state.onLoadRentChecked = true;
            } else {
                state.isRentSelected = false;
                updateExtensionProperty('isRentSelected', { BooleanValue: false }, true);
                state.onLoadRentChecked = false;
            }
        }
        if (type === 'lease') {
            if (state.isLeasedSelected === false) {
                state.isLeasedSelected = true;
                updateExtensionProperty('isLeasedSelected', { BooleanValue: true }, true);
            } else {
                state.isLeasedSelected = false;
                updateExtensionProperty('isLeasedSelected', { BooleanValue: false }, true);
            }
        }
        if (type === 'used') {
            if (state.isUsedSelected === false) {
                state.isUsedSelected = true;
                updateExtensionProperty('isUsedSelected', { BooleanValue: true }, true);
            } else {
                state.isUsedSelected = false;
                updateExtensionProperty('isUsedSelected', { BooleanValue: false }, true);
            }
        }
        if (type === 'new') {
            if (state.isNewSelected === false) {
                state.isNewSelected = true;
                updateExtensionProperty('isNewSelected', { BooleanValue: true }, true);
            } else {
                state.isNewSelected = false;
                updateExtensionProperty('isNewSelected', { BooleanValue: false }, true);
            }
        }
    };

    if (product?.ExtensionProperties && product.ExtensionProperties.length > 0) {
        product.ExtensionProperties.map(function(property) {
            if (property.Key === 'CommerceEnableRental') {
                if (property.Value?.StringValue === '1') {
                    showRental = true;
                    if (state.isFirstRender === true) {
                        state.isRentSelected = true;
                        updateExtensionProperty('isRentSelected', { BooleanValue: true }, true);
                        state.onLoadRentChecked = true;
                    }
                }
            }
            if (property.Key === 'CommerceEnableBuyUse') {
                if (property.Value?.StringValue === '1') {
                    showUsed = true;
                }
            }
            if (property.Key === 'CommerceEnableLeasing') {
                if (property.Value?.StringValue === '1') {
                    showLeased = true;
                }
            }
            if (property.Key === 'CommerceEnableBuyNew') {
                if (property.Value?.StringValue === '1') {
                    showBuyNew = true;
                }
            }
            if (property.Key === 'productTypeError' && property.Value?.BooleanValue === true) {
                if (property.Value.BooleanValue === true) {
                    showProductTypeError = true;
                } else {
                    showProductTypeError = false;
                }
            }
            if (property.Key === 'UsedEquipment') {
                if (property.Value?.StringValue === '1') {
                    usedEquipmentFlag = true;
                }
            }
        });
        if (showRental === false && showUsed === false && showLeased === false && showBuyNew === false) {
            showNoOptions = true;
            state.isNoOptions = true;
        }
    }
    if (usedEquipmentFlag) {
        return null;
    }
    return (
        <div className='ms-buybox__item-type'>
            {showRental && (
                <div className='checkbox-wrapper-main'>
                    <label className='checkbox-wrapper'>
                        <input
                            type='checkbox'
                            className='checkbox-input'
                            name='type'
                            value='rent'
                            onChange={() => onChange('rent')}
                            checked={state.onLoadRentChecked}
                        />
                        <span className='checkbox-tile'>
                            <span className='checkbox-label'>{resources.productOptionRentText}</span>
                        </span>
                    </label>
                </div>
            )}
            {showLeased && (
                <div className='checkbox-wrapper-main'>
                    <label className='checkbox-wrapper'>
                        <input type='checkbox' className='checkbox-input' name='type' value='lease' onChange={() => onChange('lease')} />
                        <span className='checkbox-tile'>
                            <span className='checkbox-label'>{resources.productOptionLeaseText}</span>
                        </span>
                    </label>
                </div>
            )}
            {showUsed && (
                <div className='checkbox-wrapper-main'>
                    <label className='checkbox-wrapper'>
                        <input type='checkbox' className='checkbox-input' name='type' value='used' onChange={() => onChange('used')} />
                        <span className='checkbox-tile'>
                            <span className='checkbox-label'>{resources.productOptionUsedText}</span>
                        </span>
                    </label>
                </div>
            )}
            {showBuyNew && (
                <div className='checkbox-wrapper-main'>
                    <label className='checkbox-wrapper'>
                        <input type='checkbox' className='checkbox-input' name='type' value='new' onChange={() => onChange('new')} />
                        <span className='checkbox-tile'>
                            <span className='checkbox-label'>{resources.productOptionNewText}</span>
                        </span>
                    </label>
                </div>
            )}
            {showNoOptions && <div className='text-danger'>{resources.productNoLongerAvailableText}</div>}
            {showProductTypeError && <div className='text-danger error-no-option'>{resources.chooseOptiontext}</div>}
        </div>
    );
}
